import React from 'react';
import ModulePage from '../components/ModulePage';
import { moduleLandingData } from '../mock/moduleLandingData';

export default function LogisticsPage() {
  return <ModulePage data={moduleLandingData.logistics} />;
}
